<section class="idh-wrapper">
  <ul class="timeline_block">
    @for (list of lists; track list) {
      <li class="timeline_list">
        <p class="dot">
          <span class="dot-span start"></span>
          <span class="dot-span end"></span>
        </p>
        <p class="qty-text start">{{list.initialQty}}&nbsp;<span class="qty-text-span">({{actualQuantity}})</span></p>
        <div class="derivation_details">
          <div class="daywise-list">
            @for (detail of list.details; track detail) {
              <div class="daywise-listitem">
                <span>{{detail.count >= 0 ? added:subtracted}} </span>&nbsp;
                <span [ngClass]="detail.count >= 0 ?'added':'subtract'">{{detail.count >= 0 ? '+':''}}{{detail.count | decimalFormatter}}&nbsp;({{detail.unit}})</span>&nbsp;
                <span>{{in}}</span>&nbsp;&nbsp;
                <span class='text-capitalize'>{{detail.unitName}}</span>
                @if (detail.fromBarCode) {
                  <i class="icon-bar-code-icon barCode"></i>
                }
              </div>
            }
          </div>
        </div>
        <p class="qty-text end">{{list.endQty}}&nbsp;<span class="qty-text-span end">({{finalQuantity}})</span></p>
      </li>
    }
  </ul>
</section>
